import React,{ useEffect } from "react";
import "../card.css";
import { useNavigate } from 'react-router-dom';
import useAnimateOnScroll from "../hooks/useAnimateOnScroll.js";
import AudioPlayer from "./Audioplayer";

const Portfolio = () => {
  const navigate = useNavigate(); 

  const handleAudioClick= () => { 
    navigate('/portfolio/audio');
  };

  const handleVideoClick= () => { 
    navigate('/portfolio/video');
  };

  const handlePhotographyClick= () => { 
    navigate('/portfolio/photography');
  };

  useAnimateOnScroll(); 

  return (
    <div id="portfolio" className="container view"> 
      <ul id="cards">
        <li class="card" id="card00">
          <div class="card-body">
          <h1>Portfolio</h1>
          <div class="arrow"></div>
          <div class="arrow"></div>
          </div>
        </li>
        <li class="card" id="card01">
          <div class="card-body" onClick={handleAudioClick}>
            <div className="link" onClick={handleAudioClick}>
              <h2>Audio</h2> 
            </div>
          </div>
        </li>
        <li class="card" id="card02">
          <div class="card-body" onClick={handleVideoClick}>
            <div className="link" onClick={handleVideoClick}>
              <h2>Video</h2>
            </div>
          </div>
        </li>
        <li class="card" id="card03">
          <div class="card-body" onClick={handlePhotographyClick}>
            <div className="link" onClick={handlePhotographyClick}>
              <h2>Photography</h2>
            </div>
          </div>
        </li>
      </ul>
    </div> 
  );
};

export default Portfolio;